var _rect, _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRequestInformationActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FDE0E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 14C14 13.7348 14.1054 13.4804 14.2929 13.2929C14.4804 13.1054 14.7348 13 15 13H25C25.2652 13 25.5196 13.1054 25.7071 13.2929C25.8946 13.4804 26 13.7348 26 14C26 14.2652 25.8946 14.5196 25.7071 14.7071C25.5196 14.8946 25.2652 15 25 15H15C14.7348 15 14.4804 14.8946 14.2929 14.7071C14.1054 14.5196 14 14.2652 14 14ZM14 18C14 17.7348 14.1054 17.4804 14.2929 17.2929C14.4804 17.1054 14.7348 17 15 17H25C25.2652 17 25.5196 17.1054 25.7071 17.2929C25.8946 17.4804 26 17.7348 26 18C26 18.2652 25.8946 18.5196 25.7071 18.7071C25.5196 18.8946 25.2652 19 25 19H15C14.7348 19 14.4804 18.8946 14.2929 18.7071C14.1054 18.5196 14 18.2652 14 18ZM15 21C14.7348 21 14.4804 21.1054 14.2929 21.2929C14.1054 21.4804 14 21.7348 14 22C14 22.2652 14.1054 22.5196 14.2929 22.7071C14.4804 22.8946 14.7348 23 15 23H25C25.2652 23 25.5196 22.8946 25.7071 22.7071C25.8946 22.5196 26 22.2652 26 22C26 21.7348 25.8946 21.4804 25.7071 21.2929C25.5196 21.1054 25.2652 21 25 21H15ZM14 26C14 25.7348 14.1054 25.4804 14.2929 25.2929C14.4804 25.1054 14.7348 25 15 25H19C19.2652 25 19.5196 25.1054 19.7071 25.2929C19.8946 25.4804 20 25.7348 20 26C20 26.2652 19.8946 26.5196 19.7071 26.7071C19.5196 26.8946 19.2652 27 19 27H15C14.7348 27 14.4804 26.8946 14.2929 26.7071C14.1054 26.5196 14 26.2652 14 26Z",
    fill: "url(#paint0_linear_496_259189)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12C10 11.2044 10.3161 10.4413 10.8787 9.87868C11.4413 9.31607 12.2044 9 13 9H27C27.7956 9 28.5587 9.31607 29.1213 9.87868C29.6839 10.4413 30 11.2044 30 12V28C30 28.7956 29.6839 29.5587 29.1213 30.1213C28.5587 30.6839 27.7956 31 27 31H13C12.2044 31 11.4413 30.6839 10.8787 30.1213C10.3161 29.5587 10 28.7956 10 28V12ZM13 11H27C27.2652 11 27.5196 11.1054 27.7071 11.2929C27.8946 11.4804 28 11.7348 28 12V28C28 28.2652 27.8946 28.5196 27.7071 28.7071C27.5196 28.8946 27.2652 29 27 29H13C12.7348 29 12.4804 28.8946 12.2929 28.7071C12.1054 28.5196 12 28.2652 12 28V12C12 11.7348 12.1054 11.4804 12.2929 11.2929C12.4804 11.1054 12.7348 11 13 11Z",
    fill: "url(#paint1_linear_496_259189)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_496_259189",
    x1: 14,
    y1: 13,
    x2: 26.2059,
    y2: 13.1819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_496_259189",
    x1: 10,
    y1: 9,
    x2: 30.3426,
    y2: 9.3215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4112E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestInformationActive);
export default __webpack_public_path__ + "static/media/RequestInformationActive.94662bfcd90844aafca88fc915db6d43.svg";
export { ForwardRef as ReactComponent };